import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Alert } from "../ui/alert";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import {
  Form,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
} from "../ui/form";
import { getApiUrl } from "../../config/api";

const CreateOrganization = ({ onSuccess }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(getApiUrl("organizations"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to create organization");
      }

      const data = await response.json();
      setFormData({ name: "", description: "" });
      if (onSuccess) {
        onSuccess(data.organization);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container max-w-md mx-auto">
      <Card className="mt-8">
        <CardHeader>
          <CardTitle>Create New Organization</CardTitle>
        </CardHeader>
        <CardContent>
          {error && (
            <Alert variant="destructive" className="mb-4">
              {error}
            </Alert>
          )}
          <Form onSubmit={handleSubmit} className="space-y-4">
            <FormItem>
              <FormLabel>Organization Name *</FormLabel>
              <FormControl>
                <Input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter organization name"
                  required
                />
              </FormControl>
            </FormItem>

            <FormItem>
              <FormLabel>Description</FormLabel>
              <FormControl>
                <Textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Enter organization description"
                  rows={4}
                />
              </FormControl>
              <FormDescription>
                Optional description of the organization
              </FormDescription>
            </FormItem>

            <Button
              type="submit"
              className="w-full"
              disabled={loading || !formData.name.trim()}
            >
              {loading ? "Creating..." : "Create Organization"}
            </Button>
          </Form>
        </CardContent>
      </Card>
    </div>
  );
};

export default CreateOrganization;
